class PerfectCombination extends HTMLElement {
  /** @type {any} */
  #swiper = null;

  connectedCallback() {
    // swiper-bundle.min.js is a deferred script rendered just above this module,
    // so the global is guaranteed to exist by DOMContentLoaded.
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.#initialize(), { once: true });
    } else {
      this.#initialize();
    }
  }

  disconnectedCallback() {
    this.#swiper?.destroy(true, true);
    this.#swiper = null;
  }

  #initialize() {
    if (!this.isConnected || this.#swiper) return;

    const container = this.querySelector('[data-perfect-swiper]');
    const SwiperClass = /** @type {any} */ (window).Swiper;
    if (!container || !SwiperClass) return;

    const slideCount = Number(this.dataset.slideCount || 0);

    this.#swiper = new SwiperClass(container, {
      slidesPerView: 1.9,
      spaceBetween: 20,
      loop: slideCount > 3,
      loopAdditionalSlides: 2,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      navigation: {
        nextEl: this.querySelector('[data-perfect-next]'),
        prevEl: this.querySelector('[data-perfect-previous]'),
      },
      pagination: {
        el: this.querySelector('[data-perfect-pagination]'),
        type: 'bullets',
        clickable: true,
      },
      breakpoints: {
        750: {
          slidesPerView: 2.3,
        },
      },
    });
  }
}

if (!customElements.get('perfect-combination')) {
  customElements.define('perfect-combination', PerfectCombination);
}
